export default {
  SET_STATEMENTS: function (state, payloads) {
    state.statements = payloads;
  }
}
